import styled from "@emotion/styled";
import { Omit } from "utility-types";
import { IconCommonProps } from "./IconCommonProps";

type IconStyledProps = Omit<IconCommonProps, "dangerouslySetSvg"> & {
    height: string;
    width: string;
};

export const IconStyled = styled("span", {
    shouldForwardProp: (propName) => {
        switch (propName) {
            // These are a little confusing to see in the HTML and the CSS so let's filter them out
            // since they don't do anything here as HTML attributes.
            case "height":
            case "width":
            case "color":
            case "svgCss":
                return false;
            default:
                return true;
        }
    },
})<IconStyledProps>(
    ({ color, height, width }) => ({
        display: "flex",
        flexShrink: 0,
        color,
        height,
        width,
    }),
    ({ svgCss = {} }) => ({
        "> svg": {
            overflow: "hidden",
            pointerEvents: "none",
            verticalAlign: "bottom",

            // We're intentionally add this spread here since we control the following props more carefully.
            ...(svgCss as Record<string, unknown>),

            height: "100%",
            width: "100%",
        },
    })
);

IconStyled.displayName = "IconWrapper";
